// Studio gallery images (user-provided, black & white)
export const galleryImages = [
  {
    src: "https://customer-assets.emergentagent.com/job_photo-studio-hub-27/artifacts/lymqqdo9_IMG_7990.jpg",
    alt: "SO studio cyclorama with lighting setup",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_photo-studio-hub-27/artifacts/sjfx5n2v_IMG_7956.jpg",
    alt: "Studio space with softboxes and white cove",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_photo-studio-hub-27/artifacts/3idp87dy_IMG_7971.jpg",
    alt: "Lounge area with glass tables and stools",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_photo-studio-hub-27/artifacts/oz4d2566_IMG_7993.jpg",
    alt: "Industrial interior with concrete columns",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_photo-studio-hub-27/artifacts/viwmpg4b_IMG_7999.jpg",
    alt: "Full studio view with lighting equipment",
  },
];

// Equipment list (from SO studio spec sheet)
export const equipmentGroups = [
  {
    title: "Light",
    items: [
      "Studio Flash",
      "4× Godox Witstro AD600BM Manual 600WS",
      "Studio Flash Continuous",
      "2× Godox Litemons LA200Bi Bi-color",
    ],
  },
  {
    title: "Light Modifiers",
    items: [
      "Manfrotto Pro Scrim 3×3",
      "Pro Beauty Dish Silver 54cm",
      "Snoot",
      "Softbox — 2× 35×160cm",
      "Softbox — 2× 50×70cm",
      "Softbox — 1× 80×120cm & Grid",
      "Godox Parabolic Softbox 120cm & Grid",
      "Godox Umbrella Black Silver Large 185cm",
      "Eyelighter 2",
      "2× Barndoor Kit with 4 Color Gel Filters",
    ],
  },
  {
    title: "Tripods & Stands",
    items: [
      "4× C-Stands / With Arm",
      "Manfrotto Boom Stand with Wheels",
      "Jinbei JB10-3000",
    ],
  },
  {
    title: "Paper Color Backgrounds",
    items: ["Black", "Green", "White"],
  },
];

export const STUDIO = {
  email: "info.sostudioath@gmail.com",
  instagram: "https://www.instagram.com/sostudio.ath/",
  instagramHandle: "@sostudio.ath",
  location: "Central Athens, Greece",
  address: "Evdokias 8, Ano Kypseli, 11364 Athens",
  mapQuery: "Ευδοκίας 8, Άνω Κυψέλη, 11364, Αθήνα",
  logo: "/so-studio-logo.png",
};
